// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import draftReferenceEntity from './entities/draft-reference.json';
import draftReferenceMenu from '../pages/draft-reference/menu.json';
import draftReferenceFullForm from '../pages/draft-reference/forms/full.json';
import draftReferenceContextForm from '../pages/draft-reference/forms/context.json';
import draftReferenceMiniForm from '../pages/draft-reference/forms/mini.json';
import draftReferenceLookupForm from '../pages/draft-reference/forms/lookup.json';
import draftReferenceTableView from '../pages/draft-reference/views/table.json';
import draftReferenceCardsView from '../pages/draft-reference/views/cards.json';
import draftReferenceDashboardView from '../pages/draft-reference/views/dashboard.json';

/** Тип запису «Посилання» зі сторінками пакета: меню, форми та подання з pages/draft-reference/. */
export const draftReferenceDefinition: IRecordTypeDefinition = {
  ...draftReferenceEntity,
  views: assembleViewSet({
      table: draftReferenceTableView,
      cards: draftReferenceCardsView,
      dashboard: draftReferenceDashboardView,
  }),
  form: draftReferenceFullForm,
  forms: { full: draftReferenceFullForm, context: draftReferenceContextForm, mini: draftReferenceMiniForm, lookup: draftReferenceLookupForm },
  menu: draftReferenceMenu,
} as IRecordTypeDefinition;
